import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Divider,
  Stack,
  Grid,
  CircularProgress,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import axiosInstance from '../../../services/axiosInstance';
import AddWalletFundsDialog from './AddWalletFundsDialog';
import { io } from 'socket.io-client';
import WalletTransactions from './WalletTransactions'; // Importamos el nuevo componente

const UserWallet = ({ user }) => {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const socket = io(process.env.REACT_APP_SERVER_URL);

  useEffect(() => {
    axiosInstance
      .get('/users/wallet')
      .then(response => {
        setBalance(response.balance);
        setTransactions(response.transactions || []);
      })
      .catch(error => {
        console.error('Error obteniendo el saldo del monedero:', error);
        toast.error('Error al cargar el saldo del monedero.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const event = `walletUpdated:${user.id}`;
    socket.on(event, walletUpdated => {
      console.log('🔄 Wallet actualizado:', walletUpdated);
      setBalance(walletUpdated);
    });

    return () => {
      socket.off(event);
    };
  }, []);

  return (
    <Box>
      <ToastContainer />
      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Monedero
          </Typography>
          <Divider sx={{ my: 2 }} />

          {loading ? (
            <Box display="flex" justifyContent="center" my={3}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor:
                  balance > 0 ? 'rgba(0, 128, 0, 0.1)' : 'rgba(255, 0, 0, 0.1)',
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={8}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AccountBalanceWalletIcon color="primary" />
                    <Typography variant="h6" color="primary">
                      Saldo Disponible: {balance.toFixed(2)} €
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={() => setOpenDialog(true)}
                    >
                      Añadir Fondos
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          )}
        </CardContent>

        <AddWalletFundsDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
        />
      </Card>

      {/* Componente separado para transacciones */}
      <WalletTransactions transactions={transactions} loading={loading} />
    </Box>
  );
};

export default UserWallet;
